import { Col } from 'antd';
import { useAppTranslation } from 'app/hooks';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GroupedPlatform } from 'redux/casinoSlice';

export interface PlatformProps {
  platform: GroupedPlatform;
  tag?: string;
}

const PlatformCard: React.FC<PlatformProps> = ({ platform, tag }) => {
  const t = useAppTranslation();
  const navigate = useNavigate();

  const handleItemClick = async (platformName: string) => {
    navigate(`/casino/all-game?platform=${platformName}`);
  };

  return (
    <Col
      key={platform.platform}
      lg={{ span: 6 }}
      md={{ span: 8 }}
      sm={{ span: 12 }}
      xs={{ span: 24 }}
      className="casino-game-item"
    >
      <div className="platform-container">
        <div className="platform-body">
          <div className="platform-body__image-container">
            <img
              src={platform.image}
              alt={platform.platform}
              className="platform-body__image"
              onError={(e) => {
                e.currentTarget.src = '/no_image.png';
              }}
            />
          </div>

          <div className="platform-infor">
            {tag && (
              <div className="corner-ribbon ">
                <span>{tag}</span>
              </div>
            )}
            <p>{platform.platform === 'PP' ? 'PRAGMATIC' : platform.platform}</p>
            <div className="platform-infor__viewmore">
              <button
                title="View more"
                className=""
                onClick={() => handleItemClick(platform.platform)}
              >
                {t('casino.showAll')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default PlatformCard;
